import React from 'react'
import PropTypes from 'prop-types'
import { Col as AntCol } from 'antd'

const Col = ({ children, offset, pull, push, span, className }) => (
  <AntCol
    offset={offset}
    pull={pull}
    push={push}
    span={span}
    className={className}
  >
    {children}
  </AntCol>
)

Col.defaultProps = {
  offset: 0,
  pull: 0,
  push: 0,
  span: 3,
  children: [],
}

Col.propTypes = {
  /** child elements... pretty much what you want the user to see */
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.node]),
  /** number out of 24 of columns to span across the row */
  span: PropTypes.number,
  /** number of columns to pretend exist to the left of this column */
  offset: PropTypes.number,
  /** the number of cells that raster is moved to the left  */
  pull: PropTypes.number,
  /** the number of cells that raster is moved to the right  */
  push: PropTypes.number,
  /** custom classname for styling */
  className: PropTypes.string,
}

export default Col
